import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Footer from '../components/Footer';
import { trackEvent } from '../services/analytics';
import { setPageMetadata } from '../services/pageMetadata';
import { submitBusinessInterest } from '../services/api';

const USE_CASES = ['Content acquisition', 'Programming', 'Distribution', 'Licensing', 'Market research', 'Content strategy', 'Investment or consulting', 'Other'];

const BingeIQBetaPage = () => {
  const [params] = useSearchParams();
  const [status, setStatus] = React.useState('idle');
  const [error, setError] = React.useState('');
  const engaged = React.useRef(false);

  React.useEffect(() => {
    setPageMetadata({
      title: 'Join the BingeIQ Beta | What to Binge',
      description: 'Request a preview of platform-specific content and territory intelligence from What to Binge.',
      canonical: 'https://what-to-binge.com/bingeiq-beta',
      noindex: true,
    });
    trackEvent('business_signup_started', { referred_title: Boolean(params.get('title')) });
  }, [params]);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    const form = new FormData(event.currentTarget);
    if (form.get('website')) return;
    setStatus('submitting');
    const payload = {
      name: String(form.get('name') || '').trim(),
      work_email: String(form.get('work_email') || '').trim().toLowerCase(),
      company: String(form.get('company') || '').trim(),
      role: String(form.get('role') || '').trim(),
      company_type: String(form.get('company_type') || '').trim() || null,
      primary_territories: String(form.get('primary_territories') || '').trim() || null,
      use_case: String(form.get('use_case') || '').trim(),
      message: String(form.get('message') || '').trim() || null,
      referred_title_key: params.get('title') || null,
      source_path: window.location.pathname,
      website: String(form.get('website') || ''),
      consent: true,
    };
    try {
      await submitBusinessInterest(payload);
    } catch (insertError) {
      setStatus('idle');
      setError('We could not save the request. Please try the contact page instead.');
      return;
    }
    setStatus('complete');
    // No names, emails, company or message contents enter consumer analytics.
    trackEvent('business_signup_completed', { use_case: payload.use_case, referred_title: Boolean(payload.referred_title_key) });
  };

  return <div className="ci-page"><header className="ci-nav"><Link to="/" className="ci-brand">What to Binge</Link><nav><Link to="/methodology">Methodology</Link><Link to="/">Discover</Link></nav></header><main className="beta-page">
    <div className="beta-intro"><p className="ci-eyebrow">BingeIQ · Private beta</p><h1>Make title intelligence specific to your platform.</h1><p>The public page shows what can be understood without a business profile. Tell us the territory and decision context you work with; we’ll use this intake only for beta access and product research.</p><ul><li>No catalog upload required</li><li>No acquisition score without platform context</li><li>No consumer activity attached to your lead</li></ul></div>
    <div className="beta-form-wrap">{status === 'complete' ? <div className="beta-success"><p className="ci-eyebrow">Request received</p><h2>Thank you.</h2><p>We’ll review your context and contact you at the work email supplied.</p><Link to="/">Continue exploring titles</Link></div> : <form className="beta-form" onSubmit={submit} onFocus={() => { if (!engaged.current) { engaged.current = true; trackEvent('business_signup_form_engaged'); } }}>
      <label>Name<input name="name" autoComplete="name" required maxLength="120" /></label>
      <label>Work email<input name="work_email" type="email" autoComplete="email" required maxLength="254" /></label>
      <label>Company<input name="company" autoComplete="organization" required maxLength="160" /></label>
      <label>Role<input name="role" autoComplete="organization-title" required maxLength="120" /></label>
      <label>Company type<select name="company_type"><option value="">Select</option><option>Streaming platform</option><option>Studio or producer</option><option>Distributor or sales agent</option><option>Broadcaster</option><option>Research or consulting</option><option>Investment</option><option>Other</option></select></label>
      <label>Primary territories<input name="primary_territories" placeholder="e.g. India, Southeast Asia" maxLength="240" /></label>
      <label className="beta-span">Current use case<select name="use_case" required defaultValue=""><option value="" disabled>Select one</option>{USE_CASES.map((item) => <option key={item}>{item}</option>)}</select></label>
      <label className="beta-span">Anything useful to know? <span>Optional</span><textarea name="message" rows="4" maxLength="1200" /></label>
      <label className="beta-honeypot" aria-hidden="true">Website<input name="website" tabIndex="-1" autoComplete="off" /></label>
      {error && <p className="beta-error" role="alert">{error} <Link to="/contact">Contact us</Link>.</p>}
      <p className="beta-privacy beta-span">By submitting, you agree that What to Binge may contact you about BingeIQ. See our <Link to="/privacy">privacy policy</Link>.</p>
      <button className="beta-submit beta-span" disabled={status === 'submitting'}>{status === 'submitting' ? 'Saving request…' : 'Request beta access'}</button>
    </form>}</div>
  </main><Footer /></div>;
};

export default BingeIQBetaPage;
